import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export function useHideOnUnmount() {
  const router = useRouter();
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    const exitingFunction = () => {
      setDisplay(false);
    };

    router.events.on('routeChangeStart', exitingFunction);

    return () => {
      router.events.off('routeChangeStart', exitingFunction);
    };
  }, [router.events]);

  return {
    display
  };
}
